export function isAuthenticated() {
  const status = sessionStorage.getItem('isAuthenticated');
  return status !== null && JSON.parse(status);
}

export function getToken() {
  const token = sessionStorage.getItem('user');
  return token !== null && JSON.parse(token);
}

export function formatTimeStampToDate(timestamp) {
  const date = new Date(Number(timestamp));

  return formatDateStrToDate(date.toISOString());
}

export function formatDateStrToDate(dateStr) {
  const dateObj = new Date(dateStr);
  const options = { day: 'numeric', month: 'long', year: 'numeric' };
  return dateObj.toLocaleDateString('en-US', options);
}

export function formatToShortDateStrToDate(dateStr) {
  const dateObj = new Date(dateStr);
  const options = { day: 'numeric', month: 'short', year: 'numeric' };
  return dateObj.toLocaleDateString('en-US', options);
}

// export function convertDateToTimeStamp(dateStr) {
//   const dateObj = new Date(dateStr);
//   const timestamp = Math.floor(dateObj.getTime());

//   return timestamp;
// }

export function convertDateToTimeStamp(dateStr) {
  const dateObj = new Date(dateStr);
  const timestamp = dateObj.getTime(); // Get the timestamp in milliseconds

  return timestamp;
}

export function clearStorage() {
  sessionStorage.clear();
}

export function windowReload() {
  const time = 1000; // since 1 millisecond = 1000seconds

  setTimeout(function () {
    window.location.reload();
  }, time);
}

export function formatAmount(number) {
  const amount = Number.isInteger(Number(number))
    ? Number(number)
    : Number(number).toFixed(5);
  return new Intl.NumberFormat().format(amount);
}

export function formatRating(rating) {
  return Number.isInteger(Number(rating))
    ? Number(rating)
    : Number(rating).toFixed(2);
}

export function formatDateToTimeStr(dateString) {
  const date = new Date(dateString);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';

  return `${hours % 12} : ${minutes < 10 ? '0' + minutes : minutes} ${ampm}`;
}

export function sortArray(a, b) {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
}

export function sortedAsc(objA, objB) {
  return (
    new Date(objA.created_at).getTime() - new Date(objB.created_at).getTime()
  );
}

export function calculateTotal(transactionType) {
  return transactionType.reduce((acc, curr) => acc + curr, 0);
}
